module.exports = __webpack_public_path__ + "assets/img/Type BS (22).0d850fda.jpg";